import type { JSX } from "react";
import type { ComingUpTask } from "@recipevault/shared";
import { Card, CardHeader, CardTitle, CardContent } from "@/ui/card.js";

interface LeadTimesCardProps {
  comingUp: ComingUpTask[];
}

/**
 * "Critical lead times" — upcoming prep tasks (defrost/marinate/soak/…) within the
 * digest's lookahead window (default 3 days), so a prep-day task doesn't get missed just
 * because it isn't due today. Hidden entirely when there's nothing coming up.
 */
export function LeadTimesCard({ comingUp }: LeadTimesCardProps): JSX.Element | null {
  if (comingUp.length === 0) return null;

  return (
    <section aria-label="Critical lead times">
      <Card>
        <CardHeader>
          <CardTitle>Critical lead times</CardTitle>
        </CardHeader>
        <CardContent>
          <ul className="flex flex-col gap-1">
            {comingUp.map((task, i) => (
              <li key={`${task.date}-${i}`} className="text-sm text-zinc-300">
                <span className="text-zinc-500">{task.date}</span> — {task.title}
                {task.startByTime && (
                  <span className="ml-1.5 text-xs text-amber-400">by {task.startByTime}</span>
                )}
              </li>
            ))}
          </ul>
        </CardContent>
      </Card>
    </section>
  );
}
